<template>
  <div class="store-layout">
    <BaseHeader />

    <main class="store-layout__main">
      <slot />
    </main>

    <!-- 客服机器人组件：仅客户端挂载，SSR 不渲染 -->
    <ClientOnly>
      <BaseChatbot />
    </ClientOnly>

    <BaseFooter />
  </div>
</template>

<style lang="scss" scoped>
.store-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  width: 100%;

  &__main {
    flex: 1;
    width: 100%;
    padding-top: $base-header-height;
  }

  @include respond-to-max('lg') {
    &__main {
      padding-top: $base-header-height-mobile;
    }
  }
}
</style>
